import React, { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from 'app/config/store';
import { Table, Row, Col, Tag, Spin, Modal, Space, Button, Form, Select, Breadcrumb, InputNumber } from 'antd';
import { RouteComponentProps, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getEcole } from '../ecole/ecole.reducer';
import { faSearch, faDownload, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { getSession } from 'app/shared/reducers/authentication';
import { getScolarite, getScolarites } from './scolarite.reducer';
import {
  getFactures,
  sendFacturesToParents,
  downloadFactureByScolariteID,
  getFacture,
  partialUpdateFacture,
} from '../factures/facture.reducer';
import { JhiItemCount, JhiPagination, getSortState } from 'react-jhipster';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import SuiviScolarite from './SuiviScolarite';
import FileUploadHandler from '../factures/FileUploadHandler';
import { StatutScolarite } from 'app/shared/model/scolarite.model';
import { FactureDetails, FactureRow, StatutFacture } from 'app/shared/model/facture.model';
import { EditOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { StatusAnneeScolaire } from 'app/shared/model/anneeScolaire.model';
import { getAnneeScolaire } from '../annee-scolaire/annee-scolaire.reducer';
import { useCheckIsAnneeInactive } from 'app/hooks/useCheckIsAnneeActive';
import { formattedDate } from 'app/config/dayjs';

const ListFactures = (props: RouteComponentProps<{ ecoleid: string; id: string; anneeScolaireId: string }>) => {
  const ecoleId = props.match.params.ecoleid;
  const dispatch = useAppDispatch();
  const [sendingFacture, setSendingFacture] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const factureList = useAppSelector(state => state.facture.entities);
  const currentFacture = useAppSelector(state => state.facture.entity);
  const anneeScolaire = useAppSelector(state => state.anneeScolaire.entity);
  const totalItems = useAppSelector(state => state.facture.totalItems);
  const scolarite = useAppSelector(state => state.scolarite.entity);
  const loading = useAppSelector(state => state.facture.loading);
  const [apiUrl, setApiUrl] = useState(`/download/${props.match.params.id}`);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const { match } = props;
  const [editingKey, setEditingKey] = useState('');
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const inactiveAnnee = useCheckIsAnneeInactive(props.match.params.anneeScolaireId);

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  useEffect(() => {
    dispatch(getAnneeScolaire(props.match.params.anneeScolaireId));
    const data = factureList
      .map((facture, i) => ({
        key: facture.eleveId,
        id: facture.factureId,
        matricule: facture.matricule || '',
        eleve: facture.eleve || '',
        parent: facture.parent || '',
        telephone: facture.telephone || '',
        classe: facture.classe || '',
        montant: facture.montant ? parseFloat(facture.montant.toString()) : 0,
        statutFacture: facture.statutFacture,
      }))
      .reverse();
    setDataSource(data);
  }, [factureList]);

  useEffect(() => {
    dispatch(getSession());
    dispatch(getScolarite(props.match.params.id));
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(
      getScolarites({
        ecoleId: props.match.params.ecoleid,
        anneeScolaireId: props.match.params.anneeScolaireId,
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
      })
    );
    factureListe();
  }, [paginationState]);

  const factureListe = () => {
    const entity = {
      ecoleId: props.match.params.ecoleid,
      id: props.match.params.id,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getFactures(entity));
  };

  const downloadFile = async () => {
    setReloadData(true);
    try {
      await dispatch(downloadFactureByScolariteID(apiUrl));
      setReloadData(true);
    } catch (error) {
      console.error('Erreur lors du téléchargement :', error);
    } finally {
      setReloadData(false);
    }
  };

  const sendFacture = async () => {
    setSendingFacture(true);
    const entity = {
      scolariteId: props.match.params.id,
    };
    await dispatch(sendFacturesToParents(entity));
    setSendingFacture(false);
    setReloadData(true);
  };

  const handlePagination = (currentPage: number) => {
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });
  };

  const isEditing = (record: FactureRow) => record.key === editingKey;

  const edit = async (record: FactureRow) => {
    await dispatch(getFacture(record.id));

    form.setFieldsValue({ montant: record.montant });
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey('');
  };

  const save = async (record: FactureRow) => {
    try {
      const row: { montant: number } = await form.validateFields();
      const updatedFacture = { ...currentFacture, montant: row.montant, id: record.id };

      setEditingKey('');

      dispatch(partialUpdateFacture(updatedFacture));
    } catch (err) {
      console.error('Erreur:', err);
    }
  };

  const renderOption = (id, record) => {
    return (
      <Space size="middle">
        <Button type="default" size="small">
          <Link to={`/scolarite/${ecoleId}/${props.match.params.anneeScolaireId}/${record.id}/details`}>
            <FontAwesomeIcon color="#91d5ff" icon="eye" />{' '}
          </Link>
        </Button>
      </Space>
    );
  };

  const column = [
    {
      title: 'Matricule',
      dataIndex: 'matricule',
      key: 'matricule',
      align: 'center' as const,
    },
    {
      title: 'Elèves',
      dataIndex: 'eleve',
      key: 'eleve',
      align: 'center' as const,
      render: (_, facture) => (
        <Link to={`/eleve/${props.match.params.ecoleid}/${props.match.params.anneeScolaireId}/${facture.key}/details`}>
          <span style={{ color: '#07aefc' }}>{`${facture.eleve}`}</span>
        </Link>
      ),
    },
    {
      title: 'Parent',
      dataIndex: 'parent',
      key: 'parent',
      align: 'center' as const,
    },
    {
      title: 'Téléphone Parent',
      dataIndex: 'telephone',
      key: 'telephone',
      align: 'center' as const,
    },
    {
      title: 'Classe',
      dataIndex: 'classe',
      key: 'classe',
      align: 'center' as const,
    },
    {
      title: 'Montant',
      dataIndex: 'montant',
      key: 'montant',
      align: 'center' as const,
      render(montant, record) {
        const editing = isEditing(record);
        if (editing) {
          return (
            <Form.Item
              name="montant"
              style={{ margin: 0 }}
              rules={[
                { required: true, message: 'Veuillez entrer un montant' },
                {
                  validator(_, value) {
                    if (value <= 0) {
                      return Promise.reject('Le montant ne peut pas être zéro ou négatif');
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber autoFocus />
            </Form.Item>
          );
        }
        return (
          <Row align="middle" style={{ justifyContent: 'center', gap: 8 }}>
            <span>{montant} FCFA</span>
            <Button
              onClick={() => edit(record)}
              type="text"
              icon={<EditOutlined />}
              hidden={
                record.statutFacture === StatutFacture.EMISE ||
                record.statutFacture === StatutFacture.PAYEE ||
                editingKey !== '' ||
                inactiveAnnee
              }
            />
          </Row>
        );
      },
    },
    {
      title: 'Statut Facture',
      dataIndex: 'statutFacture',
      key: 'statutFacture',
      align: 'center' as const,
      render: statutFacture =>
        statutFacture === StatutFacture.EN_ATTENTE ? (
          <Tag color="red">En attente</Tag>
        ) : statutFacture === StatutFacture.EMISE ? (
          <Tag color="blue">Envoyée</Tag>
        ) : statutFacture === StatutFacture.PAYEE ? (
          <Tag color="green">Payée</Tag>
        ) : statutFacture === StatutFacture.CREE ? (
          <Tag color="#999">Crée</Tag>
        ) : (
          <Tag color="#999">{statutFacture}</Tag>
        ),
    },
    ...(editingKey !== ''
      ? [
          {
            title: 'Option',
            key: 'option',
            align: 'center' as const,
            render(_, record) {
              const editable = isEditing(record);
              return (
                editable && (
                  <Space>
                    <Button type="link" icon={<CheckOutlined title="Sauvegarder" />} onClick={() => save(record)} />
                    <Button type="link" icon={<CloseOutlined title="Annuler" />} onClick={cancel} />
                  </Space>
                )
              );
            },
          },
        ]
      : []),
    {
      title: 'Details',
      dataIndex: 'id',
      key: 'id',
      align: 'center' as const,
      render: renderOption,
    },
  ];

  const showConfirmModal = () => {
    const confirmModal = Modal.confirm({
      title: 'Confirmation',
      content: 'Voulez-vous vraiment envoyer les factures aux parents?',
      okText: 'Oui',
      cancelText: 'Non',
      async onOk() {
        const loadingModal = Modal.info({
          title: 'Veuillez patienter',
          content: 'Envoi des factures en cours. Merci de patienter...',
          closable: false,
          okText: 'Fermer',
          onOk() {
            loadingModal.destroy();
            confirmModal.destroy();
          },
        });

        try {
          setSendingFacture(true);
          const entity = {
            scolariteId: props.match.params.id,
            ecoleId: props.match.params.ecoleid,
          };
          await dispatch(sendFacturesToParents(entity));
          dispatch(getScolarite(props.match.params.id));
          setSendingFacture(false);
          setReloadData(true);
          loadingModal.destroy();
          confirmModal.destroy();
        } catch (error) {
          loadingModal.destroy();
          confirmModal.destroy();
          Modal.error({
            title: "Erreur lors de l'envoi des factures",
            content: "Une erreur s'est produite lors de l'envoi des factures. Veuillez réessayer.",
            okText: 'Fermer',
          });
        }
      },
      onCancel() {
        confirmModal.destroy();
      },
    });
  };

  const onSearch = vals => {
    const entity = {
      ...vals,
      ecoleId: props.match.params.ecoleid,
      id: props.match.params.id,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getFactures(entity));
    let searchUrl = '';
    if (vals.statutFacture) {
      searchUrl = `?statutFacture=${vals.statutFacture}`;
    }
    setApiUrl(`/download/${props.match.params.id}${searchUrl}`);
  };

  const handleChange = () => {
    const entity = {
      ecoleId: props.match.params.ecoleid,
      id: props.match.params.id,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getFactures(entity));
  };
  const isInscription = scolarite?.id !== null && scolarite?.mois === 'INSCRIPTION';

  return (
    <div>
      <Breadcrumb className="p-2">
        <Breadcrumb.Item>
          <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/scolarite/${currentEcole && currentEcole.id}`}>Scolarite</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`${match.url}`}>Factures</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <SuiviScolarite scolariteId={props.match.params.id} />
      </div>
      {isInscription ? (
        <h3>Factures d&apos;inscription – Campagne du {formattedDate(scolarite.dateDebut)}</h3>
      ) : (
        <h3>Factures du Mois de {scolarite?.mois}</h3>
      )}
      <Form name="basic" layout="inline" onFinish={onSearch}>
        <Row className="p-1 my-4">
          <Col span={20} sm={20} md={20} xs={17} xxl={20} xl={20} lg={24}>
            <Form.Item name="statutFacture">
              <Select placeholder="Status" allowClear onClear={handleChange}>
                <Select.Option value={StatutFacture.CREE}>
                  <Tag color="grey">Crée</Tag>
                </Select.Option>
                <Select.Option value={StatutFacture.EN_ATTENTE}>
                  <Tag color="red">En attente</Tag>
                </Select.Option>
                <Select.Option value={StatutFacture.EMISE}>
                  <Tag color="blue">Envoyée</Tag>
                </Select.Option>
                <Select.Option value={StatutFacture.PAYEE}>
                  <Tag color="green">Payée</Tag>
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={1} sm={1} md={1} xs={1} xxl={1} xl={1} lg={3}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                <FontAwesomeIcon icon={faSearch} />
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between" align="middle">
          <Col>
            <Button className="m-1 ml-4" type="primary" onClick={downloadFile} disabled={reloadData} loading={reloadData}>
              <FontAwesomeIcon icon={faDownload} />
              &nbsp;{'Télécharger'}
            </Button>
          </Col>
          {anneeScolaire.statutAnneeScolaire !== StatusAnneeScolaire.CLOTUREE && (
            <Col>
              <FileUploadHandler ecoleId={props.match.params.ecoleid} scolariteId={props.match.params.id} />
            </Col>
          )}
        </Row>
        {anneeScolaire.statutAnneeScolaire !== StatusAnneeScolaire.CLOTUREE && (
          <Row justify="space-between" align="middle" className="ml-auto">
            <Button
              onClick={showConfirmModal}
              className="btn jh-create-entity"
              data-cy="entityCreateSaveButton"
              id="send-facture"
              style={{ backgroundColor: '#1e9b52', color: 'white', fontWeight: 700 }}
              disabled={(scolarite && scolarite.statutScolarite === StatutScolarite.EMIS) || sendingFacture}
            >
              <FontAwesomeIcon icon={faPaperPlane} />
              &nbsp;Envoyer les factures aux parents
            </Button>
          </Row>
        )}
        <div className="table-responsive">
          <Spin spinning={loading} tip="Chargement...">
            <Form form={form} component={false}>
              <Table
                columns={column}
                dataSource={dataSource.reverse()}
                bordered
                pagination={false}
                style={{ textAlign: 'center' }}
                rowClassName="editable-row"
              />
            </Form>
          </Spin>
        </div>
        {totalItems ? (
          <div className={factureList && factureList.length > 0 ? 'table-responsive' : 'd-none'}>
            <Row className="justify-content-center">
              <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
            </Row>
            <Row className="justify-content-center">
              <JhiPagination
                activePage={paginationState.activePage}
                onSelect={handlePagination}
                maxButtons={5}
                itemsPerPage={paginationState.itemsPerPage}
                totalItems={totalItems}
              />
            </Row>
          </div>
        ) : (
          ''
        )}
      </Form>
    </div>
  );
};

export default ListFactures;
